<template>
  <b-table
      v-if="!!auction"
      responsive
      hover
      head-variant="light"
      :items="auction.price_log"
      :fields="fields"
  />
</template>

<script>
export default {
  name: "auction-price-log",
  props: {
    auction: Object,
  },
  data() {
    return {
      fields: [
        {
          key: 'created',
          sortable: true,
          label: 'When',
          sortByFormatted: true,
          formatter: (v) => {
            return v ? new Date(v).toLocaleString() : ''
          },
          tdClass: 'text-nowrap'
        },
        {key: 'last_price', sortable: true, label: 'Last Price', formatter: (v) => this.$options.filters.money(v)},
        {key: 'new_price', sortable: true, label: 'New Price', formatter: (v) => this.$options.filters.money(v)},
        {
          key: 'createdby_user',
          sortable: true,
          label: 'User',
          tdClass: 'text-nowrap',
          formatter: ({userid}) => userid
        }
      ]
    }
  }
}
</script>

<style scoped>

</style>